module.exports = __webpack_public_path__ + "assets/img/Ludimos-cricket-player.f663a20c.jpg";